// -------- SET TO TRUE TO LOCAL DEVELOPMENT ----------- //
export const useLocalAPIAndAuth = process.env.NODE_ENV === "development";
// -------- SET TO TRUE FOR LOCAL DEVELOPMENT ----------- //
